// extracted by mini-css-extract-plugin
module.exports = {"textSuggestion":"TextAreaWithSuggestions_textSuggestion__J4W2A","editButton":"TextAreaWithSuggestions_editButton__x8Adk"};